if (jQuery('.blog').length > 0 || jQuery('.archive.tag').length > 0 || jQuery('.archive.category').length > 0) {
    jQuery(document).ready(function($) {
        const loadMoreButton = jQuery('.load-more__button');
        const newsList = jQuery('.repeater__holder');

        loadMoreButton.on('keydown', function(event) {
            if (event.key === "Enter") {

                // event.preventDefault(); // Prevent default action of the Enter key

                // Trigger the load more action
                loadMoreButton.click();

                // Use a small timeout to ensure the items are loaded
                setTimeout(function() {
                    const lastNewsItem = newsList.find('li').last();
                    lastNewsItem.find('a').focus();
                }, 10); // Adjust the timeout as necessary
            }
        });
    });
}
